import { DownloadSideICon } from "@icons";
import { AppState, currentReportCampaign, downloadStaticReportFileAction } from "@store";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import "./StaticReportDownload.css";
import { SvgIcon } from "./SvgIcon";
import { LoadingSpinner } from "./LoadingSpinner";

interface StaticReportDownloadProps {
    campaignId: string;
    fetchState: "LOADED" | "LOADING" | "ERROR";
    downloadFile: (campaignId: string) => void;
}

interface StaticReportDownloadState {
    isTimerFinished: boolean;
}

class StaticReportDownloadComponent extends React.Component<StaticReportDownloadProps, StaticReportDownloadState> {
    constructor(props: StaticReportDownloadProps) {
        super(props);
        this.state = {
            isTimerFinished: true
        };

        this.handleStartTimer = this.handleStartTimer.bind(this);
    }

    componentDidUpdate(prevProps: StaticReportDownloadProps) {
        if (this.props.fetchState === "LOADED" && prevProps.fetchState !== "LOADED") this.handleStartTimer();
    }

    handleStartTimer() {
        this.setState({
            isTimerFinished: false
        });
        setTimeout(() => {
            this.setState({
                isTimerFinished: true
            });
        }, 3000);
    }

    render() {
        const { fetchState, campaignId, downloadFile } = this.props;
        const { isTimerFinished } = this.state;

        return (
            <div className="app-control-header-file-loader">
                {fetchState !== "LOADING" ? (
                    <button onClick={() => downloadFile(campaignId)}>
                        <SvgIcon className="app-control-header__DownloadCSVICon" svg={DownloadSideICon} />
                    </button>
                ) : (
                    <span className="app-control-header-file-loader-text">
                        <LoadingSpinner />
                    </span>
                )}
                {fetchState == "LOADED" &&
                    !isTimerFinished && (
                        <span className="app-control-header-file-loader-text">
                            Your report has been generated. Download will start automatically.
                        </span>
                    )}
                {fetchState == "ERROR" && (
                    <span className="app-control-header-file-loader-text error">
                        Something went wrong on generating process, please try again later.
                    </span>
                )}
            </div>
        );
    }
}

export const StaticReportDownload = connect(
    (state: AppState): Partial<StaticReportDownloadProps> => {
        const campaign = currentReportCampaign(state);

        return {
            fetchState: state.reports.downloadState,
            campaignId: campaign ? campaign.campaignId : undefined
        };
    },
    (dispatch: Dispatch): Partial<StaticReportDownloadProps> => {
        return {
            downloadFile: (campaignId: string) => dispatch(downloadStaticReportFileAction({ campaignId }))
        };
    }
)(StaticReportDownloadComponent);
